import React from 'react';
import styled from 'styled-components';
import media from '../../utils/media';
import { Navigation } from '.';
import { LanguageToggle } from '../LanguageToggle';
import { ImageLink } from '../Link';
import { IMAGE_TYPE, NAV_LOGO } from '../../constants';
const DesktopNavigationContainer = styled.div `
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: sticky;
  margin: 0 auto;
  width: 100%;
  height: 74px;
  max-width: 1440px;
  width: 90%;

  ${media.mobile} {
    display: none;
  }

  ${media.tablet} {
    display: none;
  }

  ${media.smallDesktop} {
    display: none;
  }
`;
const FlexContainer = styled.div `
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-shrink: 0;
`;
const ImageLinkContainer = styled.div `
  margin-right: 42px;
`;
export const DesktopNavigation = ({ navigationItems, siteLogo, currentSite, siteOwner, currentLanguage, languageToggleOptions, }) => {
    return (React.createElement(DesktopNavigationContainer, null,
        React.createElement(FlexContainer, null,
            React.createElement(ImageLinkContainer, null,
                React.createElement(ImageLink, { media: siteLogo, linkField: { value: { href: '/' } }, type: IMAGE_TYPE.ICON, desktopHeight: NAV_LOGO.HEIGHT, desktopWidth: NAV_LOGO.WIDTH })),
            navigationItems && (React.createElement(Navigation, { currentSite: currentSite, navigationItems: navigationItems, siteOwner: siteOwner, currentLanguage: currentLanguage }))),
        React.createElement(LanguageToggle, { currentLanguage: currentLanguage, languages: languageToggleOptions })));
};
